import React from 'react';
import '../../styles/pageHeader.css';

/** Titolo pagina standard: h2 + sottotesto */
const PageHeader = ({ title, subtitle, className = '' }) => {
  if (!title) return null;
  return (
    <header className={`page-header ${className}`.trim()}>
      <h2 className="page-header__title">{title}</h2>
      {subtitle ? <p className="page-header__subtitle">{subtitle}</p> : null}
    </header>
  );
};

export default PageHeader;
